/* Leucadia override of Dawn's product-form custom element.
 * Reads the SELECTED variant ID from the form (Dawn updates [name=id] when
 * the user picks a variant), looks up the matching CHL variant via byVariant
 * first, then falls back to the handle-level map for single-variant products.
 *
 * IMPORTANT: Dawn's product-info.js calls productForm.toggleSubmitButton()
 * when a variant changes — we MUST expose that method, otherwise the variant
 * change pipeline throws and the form's [name=id] never updates. Same for
 * other lifecycle methods Dawn's pubsub system may invoke. */
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class LeucadiaProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        if (!this.form) return;
        var variantInput = this.form.querySelector('[name=id]');
        if (variantInput) variantInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton ? this.submitButton.querySelector('span') : null;
        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      /* Called by Dawn's product-info.js on variant change. Without this method
       * defined, the variant-selects -> form sync pipeline throws and the
       * selected variant ID never propagates into [name=id]. */
      toggleSubmitButton(disable, text) {
        if (!this.submitButton) return;
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text && this.submitButtonText) {
            this.submitButtonText.textContent = text;
          }
        } else {
          this.submitButton.removeAttribute('disabled');
        }
      }

      /* Dawn calls these on variant change — no-ops are fine since we don't
       * need to re-render product sections via async fetch. */
      handleUpdateProductInfo() {}
      handleErrorMessage(errorMessage) {
        if (this.hideErrors) return;
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage && this.errorMessage) this.errorMessage.textContent = errorMessage;
      }
      getSectionsToRender() { return []; }
      getSectionInnerHTML() { return ''; }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton && this.submitButton.getAttribute('aria-disabled') === 'true') return;
        this.handleErrorMessage();

        if (this.submitButton) {
          this.submitButton.setAttribute('aria-disabled', 'true');
          this.submitButton.classList.add('loading');
        }
        var spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        var pathMatch = window.location.pathname.match(/\/products\/([^\/?]+)/);
        var handle = pathMatch ? decodeURIComponent(pathMatch[1]) : null;

        var variantInputEl = this.form.querySelector('[name=id]');
        var leuVariantId = variantInputEl && variantInputEl.value ? String(variantInputEl.value) : null;

        var qtyInput = this.form.querySelector('[name=quantity]') || document.querySelector('quantity-input [name=quantity], [name=quantity]');
        var qty = qtyInput ? parseInt(qtyInput.value || '1', 10) : 1;
        if (!qty || qty < 1) qty = 1;

        if (!window.LeucadiaCart || !window.LEUCADIA_CHL) {
          this.handleErrorMessage('Cart is loading. Please try again in a moment.');
          this.restoreButton();
          return;
        }

        var meta = null;
        if (window.LEUCADIA_CHL.resolve) {
          meta = window.LEUCADIA_CHL.resolve(leuVariantId, handle);
        } else if (window.LEUCADIA_CHL.lookup) {
          meta = window.LEUCADIA_CHL.lookup(handle);
        }
        if (!meta || !meta.variantId) {
          this.handleErrorMessage('This product is not available for online checkout. Please contact us.');
          this.restoreButton();
          return;
        }

        var imgEl = document.querySelector('.product__media-item.is-active img, .product__media img, .product-media img, .product-single__media img, .product__modal-opener img');
        var image = imgEl && imgEl.src ? imgEl.src : '';

        var cartKey = leuVariantId ? ('leu-' + leuVariantId) : (handle || ('chl-' + meta.variantId));

        window.LeucadiaCart.add({
          key: cartKey,
          chlVariantId: meta.variantId,
          title: meta.title,
          price: meta.price,
          image: image || meta.image || '',
          qty: qty
        });
        window.LeucadiaCart.open();

        this.restoreButton('Added ✓');
      }

      restoreButton(text) {
        var btn = this.submitButton;
        if (!btn) return;
        var original = (this.submitButtonText && this.submitButtonText.textContent) || btn.textContent;
        btn.classList.remove('loading');
        var spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.add('hidden');
        if (text && this.submitButtonText) {
          this.submitButtonText.textContent = text;
          setTimeout(function () {
            try {
              this.submitButtonText.textContent = original;
              btn.removeAttribute('aria-disabled');
            } catch (e) {}
          }.bind(this), 1200);
        } else {
          btn.removeAttribute('aria-disabled');
        }
      }
    }
  );
}
